export default {
  titleContent: {
    type: String,
    default: 'incluido'
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/components/resources/props.js